import { render, staticRenderFns } from "./MobileScreenBox.vue?vue&type=template&id=0ce2522f&"
import script from "./MobileScreenBox.vue?vue&type=script&lang=js&"
export * from "./MobileScreenBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports